module.exports = __webpack_public_path__ + "static/media/muteIcon.c3eab948.svg";